// const baseUrl = process.env.REACT_APP_BASE_URL;
const baseUrl = process.env.SHUNKAN_IDO_BASE;
const apiKey  = process.env.SHUNKAN_IDO_KEY;

async function api(path, options) {
  let body;
  const method = options.method ? options.method.toUpperCase() : 'GET';
  const params = JSON.stringify(options.params);
  const url    = buildUrl(path, method, params);

  if (method !== 'GET' && method !== 'DELETE') {
    body = params;
  }

  const response = await fetch(url, {
    method: method,
    headers: defaultHeaders(),
    body: body,
  });

  return response.json();
}

async function fetchToken({moderatorId, apiVersion}){
  const response = await api(`/api/${apiVersion}/calls/voice_token`, {
    method: 'POST',
    params: {
      conversation:{
        moderator_id: moderatorId
      }
    }
  });

  return response.token;
}

async function fetchConversation(moderatorId, client_conversation_id){
  const response = await api(`/api/v1/conversations`, {
    method: 'POST',
    params: {
      conversation:{
        moderator_id: moderatorId,
        client_conversation_id: client_conversation_id
      }
    }
  });

  return response;
}

function defaultHeaders() {
  const headers = new Headers();
  headers.set('Content-Type', 'application/json');
  headers.set('Authorization', `Bearer ${apiKey}`);

  return headers;
}

function buildUrl(path, _method, _params) {
  let url = baseUrl + path;

  return url;
}

export { api, fetchToken, fetchConversation };



